import { Check, Plus } from "lucide-react";
import { Stepper } from "@/components/Stepper";
import { mediaUrl } from "@/lib/api";
import { clp, CHARGE_LABEL, nightsList } from "@/lib/format";

function resourceFree(x, checkIn, checkOut, avail) {
  if (!x.resource) return true;
  return nightsList(checkIn, checkOut).every((d) => !avail[d] || avail[d][x.resource]);
}

export function StepExtras({ extras, selected, setSelected, checkIn, checkOut, avail, guests, baseGuests }) {
  const setQty = (id, q) => setSelected((s) => {
    const n = { ...s };
    if (q > 0) n[id] = q; else delete n[id];
    return n;
  });
  return (
    <div data-testid="step-extras">
      <p className="text-muted-foreground mb-6">Agrega lo que quieras a tu estadía. El total se actualiza al instante.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
        {extras.map((x) => {
          const qty = selected[x.id] || 0;
          const free = resourceFree(x, checkIn, checkOut, avail);
          const locked = x.adds_guests > 0 && guests > baseGuests && qty > 0;
          const slug = x.name.toLowerCase().normalize("NFD").replace(/[^a-z0-9]+/g, "-");
          return (
            <div key={x.id} data-testid={`extra-card-${slug}`}
              className={`rounded-3xl overflow-hidden border bg-white flex flex-col transition-colors ${qty ? "border-[#5E6B52] ring-2 ring-[#5E6B52]/20" : "border-border"} ${!free ? "opacity-55" : ""}`}>
              <div className="relative aspect-[16/10] bg-[#F3EDE2]">
                {x.image && <img src={mediaUrl(x.image)} alt={x.name} loading="lazy" className="h-full w-full object-cover" />}
                {qty > 0 && <span className="absolute top-3 right-3 h-8 w-8 rounded-full bg-[#5E6B52] text-white grid place-items-center"><Check className="h-4 w-4" /></span>}
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h4 className="font-serif text-xl">{x.name}</h4>
                <p className="mt-1 text-sm text-muted-foreground flex-1">{x.description}</p>
                <div className="mt-4 flex items-center justify-between gap-3">
                  <div>
                    <p className="font-semibold" data-testid={`extra-price-${slug}`}>{x.price > 0 ? clp(x.price) : "Por confirmar"}</p>
                    <p className="text-xs text-muted-foreground">{CHARGE_LABEL[x.charge_mode]}</p>
                  </div>
                  {!free ? <span className="text-xs font-semibold text-[#C84B31]">No disponible en tus fechas</span>
                    : x.charge_mode === "unit" ? (
                      qty ? <Stepper value={qty} onChange={(q) => setQty(x.id, q)} min={0} max={x.max_qty || 10} testid={`extra-qty-${slug}`} />
                        : <AddBtn onClick={() => setQty(x.id, 1)} slug={slug} />
                    ) : qty ? (
                      <button type="button" disabled={locked} onClick={() => setQty(x.id, 0)} data-testid={`extra-remove-${slug}`}
                        className="rounded-full border border-border px-4 py-2 text-sm font-semibold transition-colors hover:bg-[#F3EDE2] disabled:opacity-50">
                        {locked ? "Requerida" : "Quitar"}
                      </button>
                    ) : <AddBtn onClick={() => setQty(x.id, 1)} slug={slug} />}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function AddBtn({ onClick, slug }) {
  return (
    <button type="button" onClick={onClick} data-testid={`extra-add-${slug}`}
      className="inline-flex items-center gap-1.5 rounded-full bg-[#5E6B52] text-white px-4 py-2 text-sm font-semibold transition-colors hover:bg-[#4A5540]">
      <Plus className="h-4 w-4" /> Agregar
    </button>
  );
}
